import { portalApi } from 'store/generated/portal/employee/employee-import';

export const EmployeeImportApiTags = {
  EmployeeImport: 'EmployeeImport',
};

const taggedApi = portalApi.enhanceEndpoints({ addTagTypes: Object.values(EmployeeImportApiTags) });

const employeeImportApi = taggedApi.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1EmployeeImportExportRetrieve: build.query<any, void>({
      query: () => ({
        url: '/portal/v1/employee-import/export',
        method: 'GET',
      }),
      providesTags: [EmployeeImportApiTags.EmployeeImport],
    }),
    apiPortalV1EmployeeImportImportCreate: build.mutation<any, any>({
      query: (body) => ({
        url: '/portal/v1/employee-import/import',
        method: 'POST',
        body,
      }),
      invalidatesTags: [EmployeeImportApiTags.EmployeeImport],
    }),
    apiPortalV1EmployeeImportImportRecordsCreate: build.mutation<any, any>({
      query: (body) => ({
        url: '/portal/v1/employee-import/import-records',
        method: 'POST',
        body,
      }),
      invalidatesTags: [EmployeeImportApiTags.EmployeeImport],
    }),
    apiPortalV1EmployeeImportRecordTemplateRetrieve: build.query<any, void>({
      query: () => ({
        url: '/portal/v1/employee-import/record-template',
        method: 'GET',
      }),
      providesTags: [EmployeeImportApiTags.EmployeeImport],
    }),
    apiPortalV1EmployeeImportTemplateRetrieve: build.query<any, void>({
      query: () => ({
        url: '/portal/v1/employee-import/template',
        method: 'GET',
      }),
      providesTags: [EmployeeImportApiTags.EmployeeImport],
    }),
  }),
  overrideExisting: false,
});

export { employeeImportApi };